import { BaseModel } from "../BaseModel";

export const Guide = BaseModel.extend({
    urlRoot: "/guides"
});


// WEBPACK FOOTER //
// ./src/js/Xola/models/Guide.js